import gql from 'graphql-tag';

const PRODUCT_QUERY = gql`
  query GetItem($slug: String!) {
    getItem(slug: $slug) {        # wp_posts.post_name
      name                        # wp_posts.post_title
      description                 # wp_postmeta.meta_value (where post_id = wp_posts.id AND meta_key="product_information") + wp_posts.post_content
      specification                # wp_postmeta.meta_value (where post_id = wp_posts.id AND meta_key="specification_characterization") + wp_postmeta.meta_value (where post_id = wp_posts.id AND mate_key="specification_technical_data")
      hash_id                     # generated
      downloads {                 
        name                      # wp_postmeta.meta_value (where post_id = wp_posts.id AND meta_key="documents_X_document_title")
        type                      # wp_posts.post_mime_type (where wp.posts.id = wp_postsmeta.documents_X_product_document)
        link                      # wp_posts.guid (where wp.posts.id = wp_postsmeta.documents_X_product_document)
        date                      # generated
        size                      # generated
      }
      image_urls                  # wp_postmeta.product_gallery
    }
  }
`;

export default PRODUCT_QUERY;

/* 
# Product
SELECT posts.id, posts.post_name, posts.post_title, posts.post_content
FROM separations.wp_posts AS posts
WHERE posts.post_type = 'products' AND posts.post_status = 'publish';

# Product informtation
SELECT meta.meta_key, meta.meta_value 
FROM separations.wp_postmeta AS meta
WHERE post_id = '';

# Product file downloads
SELECT posts.mime_type, posts.guid 
FROM separations.wp_posts AS posts
WHERE posts.id = 'X'

*/





// WEBPACK FOOTER //
// ./src/graphql/queries/product.query.js